<template>
  <b-container>
    <b-card no-body>
      <b-card-header>
        <div class="card-header-actions">
          <!--- TODO: remap voor gebruik van endpoint url="/relaties/kpi"-->
          <b-input-group
            prepend="Kies relatie"
          >
            <relatie-select 
              v-model="relatie"    
            >
              <template #first>
                <b-form-select-option 
                  :value="null" 
                >
                  -- Maak een keuze --
                </b-form-select-option>
              </template>
            </relatie-select>
          </b-input-group>
        </div>
        <b-card-title>KPI's</b-card-title>
      </b-card-header>
      <router-view :relatie="relatie" />
    </b-card>
  </b-container>
</template>
<script>
import RelatieSelect from '@/components/RelatieSelect.vue'
export default {
    name: 'KpiTemplate',
    components: { RelatieSelect},
    mixins: [],
    props: {
    },
    data() {
        return  {
          busy: false,
          relaties: [],
          relatie: { "naam": "Waterweg Wonen", "id": 145 },
        }
    }
}
</script>
